import { useEffect, lazy, Suspense } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import { Loading, Layout } from 'common/components/layout';
import { retry } from 'common/helpers/routerHelper';
import { getReservationType } from 'redux/reservationTypes/actions';
import { getReservationTypeBySlug } from 'redux/reservationTypes/reducers';

const LoadableComponent = lazy(() => retry(() => import('./TypeApp')));

const App = () => {
  const params = useParams();
  const { slug } = params;
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getReservationType(slug));
  }, [dispatch, slug]);

  const reservationTypeReducer = useSelector((state) => state.reservationType);
  const reservationType = useSelector((state) =>
    getReservationTypeBySlug(state.reservationType, slug)
  );

  if (reservationTypeReducer.isListFetching || !reservationTypeReducer.data) {
    return <Loading />;
  }

  return (
    <Layout
      title={reservationType.seo.title}
      description={reservationType.seo.description}
    >
      <Suspense fallback={<Loading />}>
        <LoadableComponent />
      </Suspense>
    </Layout>
  );
};

export default App;
